import { render, staticRenderFns } from "./GrupoDetalhes.vue?vue&type=template&id=8ea049b8"
import script from "./GrupoDetalhes.vue?vue&type=script&lang=js"
export * from "./GrupoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports